import React, {Component} from 'react'
import PropTypes from 'prop-types'


class ShowTotalItems extends Component {
    render() {
        const {total} = this.props

        return (
            <div className="ShowTotalItems">
                <strong>{total} items</strong>
            </div>
        )
    }
}

ShowTotalItems.propTypes = {
    total: PropTypes.number.isRequired,
}

export default ShowTotalItems
